var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.followingList.length)?_c('div',{staticClass:"followers"},[_c('h4',[_vm._v("Following")]),_vm._l((_vm.followingList),function(follower){return [_c('UserStatus',{key:follower,attrs:{"name":follower}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }